(() => {
  if (window.initBfcmComparison) return;
  window.initBfcmComparison = (host, signal) => {
    host.querySelectorAll('[data-bfcm-compare]').forEach((stage) => {
      if (stage.dataset.comparisonReady) return;
      stage.dataset.comparisonReady = 'true';
      const comparison = stage.closest('[data-bfcm-comparison]');
      const updateScale = () => comparison.style.setProperty('--comparison-scale', String(comparison.clientWidth / 369));
      updateScale();
      const observer = new ResizeObserver(updateScale);
      observer.observe(comparison);
      signal.addEventListener('abort', () => observer.disconnect(), { once: true });
      let position = Number(stage.getAttribute('aria-valuenow')) || 51;
      let pointerId = null;
      const setPosition = (value) => {
        position = Math.min(100, Math.max(0, value));
        stage.style.setProperty('--comparison-position', `${position}%`);
        const rounded = Math.round(position);
        stage.setAttribute('aria-valuenow', String(rounded));
        stage.setAttribute('aria-valuetext', `Original image ${rounded}%, AI preview ${100 - rounded}%`);
      };
      const fromPointer = (event) => {
        const bounds = stage.getBoundingClientRect();
        if (bounds.width) setPosition((event.clientX - bounds.left) / bounds.width * 100);
      };
      const stop = (event) => {
        if (event.pointerId !== pointerId) return;
        if (stage.hasPointerCapture(pointerId)) stage.releasePointerCapture(pointerId);
        pointerId = null;
      };
      stage.addEventListener('pointerdown', (event) => {
        if (!event.isPrimary || event.button !== 0) return;
        pointerId = event.pointerId;
        stage.setPointerCapture(pointerId);
        stage.focus({ preventScroll: true });
        fromPointer(event);
      }, { signal });
      stage.addEventListener('pointermove', (event) => {
        if (event.pointerId === pointerId) fromPointer(event);
      }, { signal });
      stage.addEventListener('pointerup', stop, { signal });
      stage.addEventListener('pointercancel', stop, { signal });
      stage.addEventListener('lostpointercapture', () => { pointerId = null; }, { signal });
      stage.addEventListener('keydown', (event) => {
        if (event.ctrlKey || event.metaKey || event.altKey) return;
        const actions = { ArrowLeft: position - 4, ArrowDown: position - 4, ArrowRight: position + 4, ArrowUp: position + 4, PageDown: position - 10, PageUp: position + 10, Home: 0, End: 100 };
        if (Object.hasOwn(actions, event.key)) { event.preventDefault(); setPosition(actions[event.key]); }
      }, { signal });
    });
  };
})();
